export class Validator {

    constructor(store) {
        this.store = store;
        this.errors = []
        this.keyChange = {
            email: "e-mail",
            name: "Név",
            job: "Munkakör",
            officeid: "Iroda",
            category: "Kategória",
            brand: "Megnevezés",
            barcode: "Vonalkód",
            sn: "Szériaszám",
            model: "típus",
            comment: "Megjegyzés"
        };
    }

    async validate(process, form, original, modified) {
        console.log(process, form, original, modified)
        this.errors = [];
        if(process === 'MODIFY'){
            if(form === 'USER'){
                // Van-e változás?
                let changed = false;
                Object.entries(original).forEach(([key, value]) => {if (String(value ?? "") !== String(modified[key] ?? "")) {changed = true;}});
                if (!changed) {this.errors.push("Nincs módosítás");
                }else{
                   for (const [key, value] of Object.entries(modified)) {
                        if (key === "email") {
                            if(original.email !== modified.email){
                                await this.emailValidate(value);
                            }
                    }}
                }
            }else if(form === 'IT'){
                  // Van-e változás?
                let changed = false;
                Object.entries(original).forEach(([key, value]) => {if (String(value ?? "") !== String(modified[key] ?? "")) {changed = true;}});
                if (!changed) {this.errors.push("Nincs módosítás");}else{
                    //VONALKÓD HA VÁLTOZOTT
                    if(original.barcode !== modified.barcode){await this.barcodeValidate(modified.barcode)}
                }
            }
        }else if(process === 'SAVE'){
            if(form === 'USER'){
                for (const [key, value] of Object.entries(original)) {
                    // Kötelező mezők
                    if (["email", "name", "job"].includes(key) && value === "") {
                        this.errors.push(`${this.keyChange[key] ?? key} kitöltése kötelező.`);
                        continue;
                    }else if (["officeid"].includes(key) && Number.isNaN(value)) {
                        this.errors.push(`${this.keyChange[key] ?? key} kitöltése kötelező.`);
                        continue;
                    }
                }
                if (modified.email) {await this.emailValidate(modified.email);}
            }
            if(form === 'FURNITURE' || form === 'IT'){
                if(form === 'FURNITURE'){
                    for (const [key, value] of Object.entries(modified)) {
                        // Kötelező mezők
                        if (["brand", "officeid", ].includes(key) && value === "válassz!") {
                            this.errors.push(`${this.keyChange[key] ?? key} kitöltése kötelező.`);
                            continue;
                        }
                }
                }else if(form === 'IT'){
                    for (const [key, value] of Object.entries(modified)) {
                        // Kötelező mezők
                        if (["category", "brand"].includes(key) && value === "válassz!") {
                            this.errors.push(`${this.keyChange[key] ?? key} kitöltése kötelező.`);
                            continue;
                        }
                    }
                }
 
                //VONALKÓD
                await this.barcodeValidate(modified.barcode)
                
            }
        }

        // SQL injection
        this.SQLValidate(modified)   
           
        if (this.errors.length) {
            this.errors.forEach(err => this.store.toast.error(err));
            return false;
        }
        return true
    }

    SQLValidate(data){
        const forbidden = /(select|insert|update|delete|drop|union|--)/i;
        Object.values(data).forEach(field => {if (typeof field === "string" && forbidden.test(field)) {this.errors.push("Ne írjon SQL utasítást a beviteli mezőbe");}});
            
    }
 /*
    async emailValidate(email){
        console.log('EMAILVALIDATOR ', email)
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {this.errors.push("Az e-mail cím formátuma hibás.");}
        const exists = await this.store.datas.checkEmail(email);
        if (exists) {this.errors.push("Ez az e-mail cím már használatban van.");}
    }
*/

    async emailValidate(email) {
        let valid = 'NOTEXISTS';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            this.errors.push("Az e-mail cím formátuma hibás.");
            valid = "Az e-mail cím formátuma hibás.";
        }
        const exists = await this.store.datas.checkEmail(email);
        if (exists) {
            this.errors.push("Ez az e-mail cím már használatban van.");
            valid = "EXISTS";
        }
        return valid;
    }

    async barcodeValidate(barcode){
        if(barcode === ''){this.errors.push(`A vonalkód kitöltése kötelező.`);
        }else{
            const exists = await this.store.datas.checkBarcode(barcode);
            if (exists) {this.errors.push("Ez a vonalkód már szerepel az adatbázisban");
            } else if (!/^NAK\d{7}$/.test(barcode)) {this.errors.push("Kötelező vonalkódformátum: NAK0000000");}
        }
    
     }

     
   
}